module.exports = __webpack_public_path__ + "img/J5vo0JrT-D0.06a6e138.jpg";